import React from "react";
import {
  Grid,
  Box,
  makeStyles,
  Divider,
  useMediaQuery,
  useTheme
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "rgba(207, 218, 226, 0.16)",
    borderRadius: 5,
    marginBottom: 14,
    marginTop: 28,
    minHeight: 350,
    padding: 8,
    [theme.breakpoints.up("sm")]: {
      padding: 30
    }
  },
  sectionTitle: {
    textAlign: " center",
    color: "#004987",
    fontSize: 20,
    fontWeight: " bold",
    marginBottom: 14,
    textTransform: "uppercase"
  },
  dividerH: { backgroundColor: " #E0E0E0", width: 37 },
  dividerV: { backgroundColor: " #E0E0E0", height: 70, width: 2 },
  assistanceImage: {
    width: 100,
    height: 94,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& img": {
      height: "45px"
      // width: "100%"
    }
  },
  assistanceStep: {
    width: 30,
    height: 30,
    [theme.breakpoints.up("md")]: {
      width: 38,
      height: 38
    },
    backgroundColor: " #004987",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    color: "white",
    marginRight: 4
  }
}));

export default function AssistanceServices({ sectionTitle, section, data }) {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid container item justify="center">
          <Box component="span" className={classes.sectionTitle}>
            {sectionTitle}
          </Box>
        </Grid>
        <Grid container item justify="center">
          <Divider className={classes.dividerH} />
        </Grid>
        <Grid container item justify="center">
          <Box component="p" textAlign="center" px={sm ? 6 : 2}>
            Además, con tu seguro de{" "}
            <Box component="span" fontWeight="fontWeightBold">
              {section}
            </Box>
            , contás con los siguientes servicios adicionales, disponibles sin
            costo extra las 24 hs. todos los días del año:
          </Box>
        </Grid>
        <Grid container item sm={12} justify="center" spacing={2} mt={4}>
          {data.map((item, key) => (
            <Grid
              key={key}
              container
              item
              sm={12}
              md={6}
              justify="center"
              alignItems="center"
              wrap="nowrap"
            >
              <Grid
                item
                xs={5}
                sm={5}
                container
                alignItems="center"
                justify="center"
                spacing={1}
              >
                <Grid item xs={3} sm={4} container justify="center">
                  <Box className={classes.assistanceStep}>{item.id}</Box>
                </Grid>
                <Grid item xs={9} sm={8} container>
                  <Box className={classes.assistanceImage}>
                    {item.img && (
                      <img
                        src={require(`../../img/assistance/${item.img}.png`)}
                        alt=""
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>
              <Grid
                item
                xs={1}
                sm={2}
                container
                justify={xl ? "flex-start" : "center"}
              >
                <Divider orientation="vertical" className={classes.dividerV} />
              </Grid>
              <Grid item xs={6} sm={5} container>
                <Box component="p" fontSize={14}>
                  {item.title && (
                    <Box component="span" fontWeight="fontWeightBold">
                      {item.title.toUpperCase()}{" "}
                    </Box>
                  )}

                  {item.description}
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </div>
  );
}
